import { YOO_FINDS_CDN } from "@/common";

const ROOT = `${YOO_FINDS_CDN}/h5/task-detail`;

export const TASK_DETAIL_DDL_BG = `${ROOT}/ddl-bg.svg`;
export const TASK_DETAIL_JOIN_PROCESS = `${ROOT}/process.png`;
export const TASK_DETAIL_JOIN_PROCESS_NO_SAMPLE = `${ROOT}/process-no-sample.png`;
export const TASK_LIST_JOIN_BUTTON_BG = `${ROOT}/join-btn.png`;
export const TASK_DETAIL_NO_SAMPLE_BG = `${ROOT}/process-no-sample.png`;
export const TASK_DETAIL_SAMPLE_BG = `${ROOT}/process-sample.png`;
export const TASK_DETAIL_FINGER_ICON = `${ROOT}/finger.png`;
export const TASK_DETAIL_ARROW_ICON = `${ROOT}/arrow.png`;
export const TASK_DETAIL_E_CARD = `${ROOT}/e-card.png`;
export const TASK_DETAIL_TIPS_1 = `${ROOT}/tips-1.png`;
export const TASK_DETAIL_TIPS_2 = `${ROOT}/tips-2-3.png`;
export const TASK_DETAIL_ARROW_ICON_LEFT = `${ROOT}/arrow—left.png`;
export const TASK_DETAIL_TIP_PRODUCT = `${ROOT}/e-cover-v1.png`;
